// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  name: __t.string(),
  gmUserId: __t.string().name("gm_user_id"),
  gmName: __t.string().name("gm_name"),
  gmIdentity: __t.identity().name("gm_identity"),
  ruleset: __t.string(),
  visibility: __t.string(),
  steamLobbyId: __t.string().name("steam_lobby_id"),
  allocation: __t.string(),
  maxArmiesPerPlayer: __t.u32().name("max_armies_per_player"),
  theatreJson: __t.string().name("theatre_json"),
  factionsJson: __t.string().name("factions_json"),
  status: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
